function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Notice({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.53 1a1 1 0 011 1v20c0 .552-.449 1-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h15.53zm-1.001 2H5v18h13.529V3zm-7.158 14.372a1 1 0 110 2H7.738a1 1 0 110-2h3.633zm4.42-4.081a1 1 0 110 2H7.738a1 1 0 110-2h8.053zm0-4.082a1 1 0 110 2H7.738a1 1 0 110-2h8.053zm-3.82-4.645a1.335 1.335 0 110 2.67 1.335 1.335 0 010-2.67z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoNotice = React.memo(Notice);
export default MemoNotice;